import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { EntityRenewalService } from '../entity-renewal.service';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StorageService } from '../../../shared/security/StorageService';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { Router } from '@angular/router';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { QuestionnaireQuestionModel } from '../../../model/questionnaireQuestionModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { SelectInactiveOfficesToRenewRequestModel } from '../../../model/selectInactiveOfficesToRenewRequestModel';
import { Subscription } from 'rxjs';
import { MessageModel } from '../../../model/models';
import { SelectInactiveOfficesToRenewResponseModel } from '../../../model/selectInactiveOfficesToRenewResponseModel';
import * as $ from 'jquery';
import { IndividualRenewalService } from '../../individual-renewal/individual-renewal.service';
import { SubmitIndividualCorporationStatusResponseModel } from '../../../model/submitIndividualCorporationStatusResponseModel';
import { SubmitQuestionnaireAnswersResponseModel } from '../../../model/submitQuestionnaireAnswersResponseModel';


@Component({
  selector: 'app-questionnaire-entity-renewal',
  templateUrl: './questionnaire-entity-renewal.component.html',
  styleUrls: ['./questionnaire-entity-renewal.component.css']
})
export class QuestionnaireEntityRenewalComponent implements OnInit, OnDestroy {

  title: string = "";
  startFunction: StartFunctionResponseModel = {};
  entityRenewalQuestions: Array<QuestionnaireQuestionModel> = [];
  workflow: WorkflowModel = new WorkflowModel();
  selectInactiveOfficesToRenewResponseModel: SelectInactiveOfficesToRenewResponseModel = new SelectInactiveOfficesToRenewResponseModel();
  notifySelectInactiveOfficesToRenewResponseSubscription = new Subscription();
  userMessages: Array<MessageModel> = [];
  notifyIndividualCorporationStatusResponseSubscription = new Subscription();
  individualCorporationStatusResponse : SubmitIndividualCorporationStatusResponseModel =new SubmitIndividualCorporationStatusResponseModel();
  notifyEntityQuestionListSubscription = new Subscription();

  notifyIndividualQuestionListSubscription = new Subscription();
  individualRenewalQuestions: Array<QuestionnaireQuestionModel> = [];

  notifySubmitQuestionnaireAnswersSubscription: Subscription = new Subscription();
  submitQuestionnaireAnswersResponseModel: SubmitQuestionnaireAnswersResponseModel = new SubmitQuestionnaireAnswersResponseModel();
  
  constructor(private entityRenewalService: EntityRenewalService,
    private individualRenewalService : IndividualRenewalService,
    private startFunctionService: StartFunctionService,
    private storage: StorageService,
    private currentPageWatcher: CurrentPageWatcherService,
    private router: Router) {

    this.notifyIndividualCorporationStatusResponseSubscription=this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().subscribe(
      (data: SubmitIndividualCorporationStatusResponseModel)=>{
        this.individualCorporationStatusResponse=data;

      }
    );

    this.notifySelectInactiveOfficesToRenewResponseSubscription = this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel()
      .subscribe(selectInactiveOfficesToRenewResp => {
        this.selectInactiveOfficesToRenewResponseModel = selectInactiveOfficesToRenewResp;
  //  if(this.selectInactiveOfficesToRenewResponseModel==null){
  //         this.workflow = this.startFunction.Workflow;
  //       }
  //       else{
  //         this.workflow = this.selectInactiveOfficesToRenewResponseModel.Workflow;
  //       }
});
 
 
     
      this.notifyIndividualQuestionListSubscription = this.individualRenewalService.getNotifyIndividualQuestionList().subscribe(questionListData => {
        this.individualRenewalQuestions = questionListData;
      });

      this.notifySubmitQuestionnaireAnswersSubscription = this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().subscribe(submitQuestionnaireAnswersResp => {
        this.submitQuestionnaireAnswersResponseModel = submitQuestionnaireAnswersResp;
      });
  }

  ngOnInit() {
    this.startFunction = this.storage.getStartFunctionData();
   
    if(this.entityRenewalService.renewalWorkflowModel == undefined || this.entityRenewalService.renewalWorkflowModel==null){
      this.workflow = this.startFunction.Workflow;
    }
    else{
      this.workflow = this.entityRenewalService.renewalWorkflowModel;
    }
    // if(this.selectInactiveOfficesToRenewResponseModel.Workflow==null && this.individualCorporationStatusResponse.Workflow==null){
    //   this.workflow = this.startFunction.Workflow;
    // }
    // if(this.selectInactiveOfficesToRenewResponseModel.Workflow!=null) {
    //   this.workflow = this.selectInactiveOfficesToRenewResponseModel.Workflow;
    // }
    // if(this.selectInactiveOfficesToRenewResponseModel.Workflow==null && this.individualCorporationStatusResponse.Workflow!=null) {
    //   this.workflow = this.individualCorporationStatusResponse.Workflow;
    // }

    this.notifyEntityQuestionListSubscription= this.entityRenewalService.getEntityQuestionnaire(this.workflow.WorkflowID).subscribe(
      (questionnaireListResp: QuestionnaireQuestionModel[]) => {
        this.entityRenewalQuestions = questionnaireListResp;
        this.entityRenewalService.questionnaireQuestionModel = this.entityRenewalQuestions;
      });

}

verifyQuestionnaire(){
  if (this.entityRenewalQuestions.filter(el => el.Answer != null).length != this.entityRenewalQuestions.length) {
    let userMessage: MessageModel = {};
    userMessage.Alert = 3;
    userMessage.Description = "You must answer all of the questions.";
    this.userMessages.push(userMessage);
    $("html, body").animate({ scrollTop: 0 }, "slow");
    this.currentPageWatcher.sendUserMessages(this.userMessages);
    this.userMessages = [];
  }
  else {
    this.router.navigate(["/verifyEntityRenewalQuestionnaire"]).then(() => {
      this.startFunctionService.getNotifyStepInProgress().emit(true);
      this.entityRenewalService.getNotifyQuestionList().emit(this.entityRenewalQuestions);
      this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(this.selectInactiveOfficesToRenewResponseModel);
      this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
      this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
      this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitQuestionnaireAnswersResponseModel);

    })
  }
}

goBack(){

  let currentStep = this.workflow.Steps.indexOf(this.workflow.Steps.filter(el=>el.WorkflowStepType == 48)[0]);
  console.log(currentStep);
  if(currentStep == -1){
    currentStep = this.workflow.Steps.indexOf(this.workflow.Steps.filter(el=>el.WorkflowStepType == 53)[0]);
  }
  if(this.selectInactiveOfficesToRenewResponseModel==null){
    this.router.navigate(["/startEntityRenewal"]).then(()=>{
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      
      //this.startFunctionService.getNotifyStepInProgress().emit(false);
      
    });
  }
  if ( (this.startFunction.Workflow.Steps[currentStep - 1]).WorkflowStepType==50) {
    //individualCorporation
      this.router.navigate(["/individualCorporation"]).then(() => {
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
      this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitQuestionnaireAnswersResponseModel);
      this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);

    })
     this.userMessages = [];
   }
   //inactiveOfficesToRenew :52
   if ( (this.startFunction.Workflow.Steps[currentStep - 1]).WorkflowStepType==52 || (this.startFunction.Workflow.Steps[currentStep - 1]).WorkflowStepType==39) {
    this.router.navigate(["/inactiveOfficesToRenew"]).then(()=>{
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
      this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitQuestionnaireAnswersResponseModel);
      this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
    });
  }

  
    //previous step = individual-verify-questionnaire (WorkflowStepType : 18 ; path: /verifyIndividualRenewalQuestionnaire) 
    if(this.startFunction.Workflow.Steps[currentStep - 1].WorkflowStepType == 18){
      this.router.navigate(["/verifyIndividualRenewalQuestionnaire"]).then(() => {
        this.startFunctionService.getNotifyStepInProgress().emit(false);
        this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
        this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitQuestionnaireAnswersResponseModel);
        this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
      })
    }
  
}

//back browser button
@HostListener('window:popstate', ['$event'])
onPopState(event) {
  this.goBack();
}

ngOnDestroy(): void {
  this.currentPageWatcher.sendUserMessages(null);
  this.currentPageWatcher.clearUserMessage();
  this.currentPageWatcher.clearStepMessage();
}

}



// WEBPACK FOOTER //
// ./src/app/renewal/entity-renewal/questionnaire-entity-renewal/questionnaire-entity-renewal.component.ts